<h1 class="p-4 text-4xl font-medium">Greentripper Climate Partner</h1>
<app-cards-list [cardslist]="cardsList" />
